import React from 'react'
import styled from 'styled-components'
import { Participant as ParticipantType } from '../useTwilio'
import Participant from './Participant'

const S = {
    RemoteParticipant: styled.div<{ hidden: boolean }>`
      max-width: 260px;
      display: flex;
      flex-grow: 1;
      padding: 6px;
      border-radius: 24px;
      overflow: hidden;
      display: ${({ hidden }) => (hidden ? 'none' : 'unset')}
    `,
    SmallParticipantsLayout: styled.div`
      position: absolute;
      display: flex;
      flex-direction: row;
      flex-wrap: nowrap;
      bottom: 200px;
    `,
}

const SmallRemoteParticipant = ({
    participant,
    hidden = false,
}: { participant: ParticipantType, hidden?: boolean }) => (
    <S.RemoteParticipant hidden={hidden}>
        <Participant
            participant={participant}
            borderRadius={12}
            hidden={hidden}
        />
    </S.RemoteParticipant>
)

const SmallParticipantsLayout = ({ participants }: { participants: ParticipantType[] }) => (
    <S.SmallParticipantsLayout>
        {participants.map((participant, index) => (
            <SmallRemoteParticipant
                participant={participant}
                key={participant.sid}
                hidden={index > 11}
            />
        ))}
    </S.SmallParticipantsLayout>
)

export default SmallParticipantsLayout
